export const styleConfig = {
  // Padding
  // ------
  pad: {
    small: 40,
    medium: 40,
    large: 75,
    xlarge: 75,
  },

  // Colours
  // ------
  fonts: {
    header: 'Bai Jamjuree',
    body: 'Open Sans',
  },
  color: {
    bg: {
      white: '#ffffff',
      black: '#000000',
      offwhite: '#F8F8F8',
      darkgrey: '#2B2B2B',
      darkergrey: '#151515',
      gold: '#8B6620',
      altLightGrey: '#E7E7E7',
      // New tokens — covering the dark/warm/mid-grey spectrum used across components
      /** Near-black background (SearchBar, overlays) */
      nearblack: '#0F0F0F',
      /** Charcoal dark background (Header, MegaMenu, dark panels) */
      charcoal: '#181818',
      /** Warm cream background (reviews, testimonials) */
      cream: '#F7F5F0',
      /** Warm light accent (search option highlights) */
      warmLight: '#F7F0DE',
      /** Warm muted accent (search option hover) */
      warmMuted: '#EEE6D5',
      /** Mid-grey for dark text areas, borders on dark */
      mid: '#444444',
      /** Mid-gold accent for alpha overlays (borders, hover glows) */
      goldAccent: '#B58C40',
      /** Grouped button inactive background */
      groupedInactive: '#454545',
      /** Dark card background (review cards on dark surfaces) */
      darkCard: '#383838',
      /** Dark grey hover state */
      darkgreyHover: '#202020',
      /** Gold hover accent */
      goldHover: '#a77f35',
      /** Warm white background */
      warmWhite: '#fbfaf7',
      /** Bright gold for alpha-composed borders/accents (image wraps, selected variant borders) */
      goldBright: '#D4AF37',
      /** Warm gold gradient terminal (progress bar fill, modal gradients) */
      goldWarm: '#d1ab63',
      /** Deep gold for dark gradient endpoints (success badge radial gradient) */
      goldDeep: '#927133',
      /** Gold image overlay gradient base (LargeLinks, RescueLargeLinks) */
      goldOverlay: '#C6A15C',
      /** Light surface for slider navigation buttons */
      sliderSurface: '#F0F0F0',
      /** Dark gradient endpoint (3-tone card gradients) */
      darkGradientEnd: '#242424',
    },

    text: {
      white: '#ffffff',
      black: '#000000',
      lightgrey: '#AAAAAA',
      gray: '#757575',
      /** Muted text/icons on white and warm light surfaces (at least 4.5:1 through #F7F5F0). */
      mutedOnLight: '#6e6e6e',
      /** Gray for offwhite backgrounds — 4.82:1 on #F8F8F8 (AA compliant) */
      grayOnOffwhite: '#6e6e6e',
      darkgrey: '#2B2B2B',
      /** Light text on dark backgrounds */
      lightOnDark: '#C8C8C8',
      /** Subtle text on dark backgrounds */
      subtleOnDark: '#E0DFDE',
      // Original gold — 5.36:1 on white (#FFFFFF). Do NOT use on dark backgrounds.
      gold: '#8B6620',
      // WCAG AA-compliant gold variants for dark/overlay backgrounds.
      // All calculated using WCAG 2.1 relative luminance: L = 0.2126R + 0.7152G + 0.0722B
      //
      // goldOnDarkgrey: #C49A3C on #2B2B2B → contrast ≈ 5.52:1 (passes AA 4.5:1 normal text)
      goldOnDarkgrey: '#C49A3C',
      // goldOnDarkergrey: #C49A3C on #151515 → contrast ≈ 7.29:1 (passes AA 4.5:1 normal text)
      goldOnDarkergrey: '#C49A3C',
      // goldOnOverlay: #C49A3C on rgba(0,0,0,0.50) composite over mid-image (~#303030) → contrast ≈ 5.23:1 (passes AA 4.5:1 normal text)
      goldOnOverlay: '#C49A3C',
      lightergrey: '#999999',
      /** WCAG AA gold on #383838 dark card bg (~4.6:1). Use instead of goldOnDarkgrey on lighter dark surfaces. */
      goldOnDarkCard: '#CBA344',
      /** Error/validation red — AA-compliant on white */
      error: '#D32F2F',
    },
    // Pagination dot tokens — used across all 6 carousel components
    pagination: {
      // Active dot: original gold on light/white carousel backgrounds (same as text.gold)
      active: '#8B6620',
      // Inactive dot: muted gold at 30% opacity on white — rgba(139, 102, 32, 0.3)
      // Warm branded tone vs generic grey (#DDD), clearly distinct from active
      inactive: 'rgba(139, 102, 32, 0.3)',
    },
    button: {
      // Overlay-safe gold for button borders on dark/overlay backgrounds.
      // Same #C49A3C as goldOnOverlay text tokens — passes AA contrast on dark surfaces.
      // Standard gold (#8B6620) is too dark on overlays; keep default for white backgrounds.
      borderOnOverlay: '#C49A3C',
      // Standardised solid fill for primary conversion CTAs (hero, header, floating
      // contact). Same brand gold #C49A3C as goldOnOverlay/borderOnOverlay; pairs with
      // black label text (~8:1 contrast) and reads well on the dark hero/header surfaces
      // where the darker #8B6620 is too muted.
      primaryFill: '#C49A3C',
    },
    border: {
      /** Light border for cards/dividers on white backgrounds */
      light: '#D8D8D8',
      /** Generic light grey border (form fields, general dividers) */
      rule: '#DDDDDD',
      /** Stronger grey border for defined-grid dividers (derivative price table) */
      ruleStrong: '#CCCCCC',
      /** Lighter grey border (subtle separation on white bg) */
      faint: '#EEEEEE',
      /** Muted border for price dividers */
      muted: '#D0D0D0',
    },
    /** Star rating gold */
    star: '#FFD700',
  },
};


